// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"72823927","275":"db89df63","369":"366b458e","496":"05979550","600":"cc4f7388","820":"e1c6e2aa","856":"c5b36b8f","966":"82a2f3d8","978":"3fb4f4c6"}[chunkId] + ".chunk.js";
};